var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_816_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4211 9.40503C23.1226 9.40503 26.5294 13.2911 26.5294 17.6035C26.5294 18.9808 26.1329 20.3991 25.437 21.6945C25.3075 21.9077 25.2913 22.1782 25.3803 22.4324L25.9225 24.2688C26.0439 24.7115 25.6716 25.0395 25.2589 24.9083L23.6243 24.4164C23.1793 24.2688 22.8313 24.4574 22.4178 24.7115C21.2363 25.4166 19.7644 25.7773 18.4372 25.7773C14.4235 25.7773 10.3451 22.6373 10.3451 17.5789C10.3451 13.2173 13.8247 9.40503 18.4211 9.40503",
    fill: "url(#paint0_linear_816_2285)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_816_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5883 17.6852C23.5883 20.61 21.2486 22.98 18.3621 22.98C15.4757 22.98 13.1359 20.61 13.1359 17.6852C13.1359 14.7614 15.4757 12.3904 18.3621 12.3904C21.2486 12.3904 23.5883 14.7614 23.5883 17.6852Z",
    fill: "#8237FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_816_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3466 3C6.34723 3 2 7.95877 2 13.4615C2 15.2191 2.50597 17.0289 3.394 18.6819C3.55922 18.9539 3.57987 19.2991 3.46628 19.6234L2.77445 21.9668C2.61956 22.5317 3.09455 22.9502 3.62117 22.7828L5.70702 22.1551C6.27494 21.9668 6.71896 22.2074 7.24662 22.5317C8.7542 23.4314 10.6325 23.8917 12.326 23.8917C17.4476 23.8917 22.6519 19.8849 22.6519 13.4302C22.6519 7.86462 18.2117 3 12.3466 3Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95355 18.9185C2.95771 18.9262 2.96209 18.9339 2.96666 18.9414C3.04226 19.0659 3.0667 19.2517 2.99439 19.4581C2.99165 19.466 2.9891 19.4739 2.98675 19.4818L2.29491 21.8252L2.29482 21.8252L2.29224 21.8346C2.16883 22.2847 2.29147 22.7257 2.60096 23.0148C2.90495 23.2987 3.34446 23.3939 3.76852 23.2606L5.8511 22.6339L5.85115 22.6341L5.86438 22.6297C6.18896 22.5221 6.44361 22.6251 6.9848 22.9577L6.98478 22.9577L6.99039 22.9611C8.58306 23.9115 10.5516 24.3917 12.326 24.3917C17.6898 24.3917 23.1519 20.1938 23.1519 13.4302C23.1519 7.60587 18.505 2.5 12.3466 2.5C6.04862 2.5 1.5 7.70564 1.5 13.4615C1.5 15.3133 2.0323 17.2038 2.95355 18.9185Z",
    stroke: "url(#paint1_linear_816_2285)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_816_2285)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_816_2285",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3057 14.811C11.5726 14.8005 10.984 14.2042 10.984 13.4614C10.984 12.7291 11.5829 12.1223 12.3057 12.1328C13.0389 12.1328 13.6275 12.7291 13.6275 13.4719C13.6275 14.2042 13.0389 14.811 12.3057 14.811ZM7.54511 14.8112C6.82229 14.8112 6.22339 14.2044 6.22339 13.4721C6.22339 12.7293 6.81197 12.133 7.54511 12.133C8.27825 12.133 8.86683 12.7293 8.86683 13.4721C8.86683 14.2044 8.27825 14.8007 7.54511 14.8112ZM15.7441 13.4719C15.7441 14.2042 16.3327 14.811 17.0658 14.811C17.799 14.811 18.3876 14.2042 18.3876 13.4719C18.3876 12.7291 17.799 12.1328 17.0658 12.1328C16.3327 12.1328 15.7441 12.7291 15.7441 13.4719Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3057 14.811C11.5726 14.8005 10.984 14.2042 10.984 13.4614C10.984 12.7291 11.5829 12.1223 12.3057 12.1328C13.0389 12.1328 13.6275 12.7291 13.6275 13.4719C13.6275 14.2042 13.0389 14.811 12.3057 14.811ZM7.54511 14.8112C6.82229 14.8112 6.22339 14.2044 6.22339 13.4721C6.22339 12.7293 6.81197 12.133 7.54511 12.133C8.27825 12.133 8.86683 12.7293 8.86683 13.4721C8.86683 14.2044 8.27825 14.8007 7.54511 14.8112ZM15.7441 13.4719C15.7441 14.2042 16.3327 14.811 17.0658 14.811C17.799 14.811 18.3876 14.2042 18.3876 13.4719C18.3876 12.7291 17.799 12.1328 17.0658 12.1328C16.3327 12.1328 15.7441 12.7291 15.7441 13.4719Z",
    fill: "url(#paint2_linear_816_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3057 14.811L12.3 15.211H12.3057V14.811ZM12.3057 12.1328L12.2999 12.5328H12.3057V12.1328ZM7.54511 14.8112L7.54511 15.2112L7.55082 15.2112L7.54511 14.8112ZM10.584 13.4614C10.584 14.4213 11.3467 15.1973 12.3 15.2109L12.3114 14.411C11.7985 14.4037 11.384 13.9871 11.384 13.4614H10.584ZM12.3115 11.7329C11.3572 11.719 10.584 12.5144 10.584 13.4614H11.384C11.384 12.9438 11.8086 12.5257 12.2999 12.5328L12.3115 11.7329ZM14.0275 13.4719C14.0275 12.5131 13.2647 11.7328 12.3057 11.7328V12.5328C12.8131 12.5328 13.2275 12.9451 13.2275 13.4719H14.0275ZM12.3057 15.211C13.2667 15.211 14.0275 14.4181 14.0275 13.4719H13.2275C13.2275 13.9903 12.811 14.411 12.3057 14.411V15.211ZM5.82339 13.4721C5.82339 14.4204 6.59648 15.2112 7.54511 15.2112V14.4112C7.04811 14.4112 6.62339 13.9884 6.62339 13.4721H5.82339ZM7.54511 11.733C6.58615 11.733 5.82339 12.5134 5.82339 13.4721H6.62339C6.62339 12.9453 7.03779 12.533 7.54511 12.533V11.733ZM9.26683 13.4721C9.26683 12.5134 8.50407 11.733 7.54511 11.733V12.533C8.05244 12.533 8.46683 12.9453 8.46683 13.4721H9.26683ZM7.55082 15.2112C8.50217 15.1976 9.26683 14.4236 9.26683 13.4721H8.46683C8.46683 13.9853 8.05434 14.4039 7.5394 14.4112L7.55082 15.2112ZM17.0658 14.411C16.5605 14.411 16.1441 13.9903 16.1441 13.4719H15.3441C15.3441 14.4181 16.1049 15.211 17.0658 15.211V14.411ZM17.9876 13.4719C17.9876 13.9903 17.5712 14.411 17.0658 14.411V15.211C18.0268 15.211 18.7876 14.4181 18.7876 13.4719H17.9876ZM17.0658 12.5328C17.5732 12.5328 17.9876 12.9451 17.9876 13.4719H18.7876C18.7876 12.5131 18.0248 11.7328 17.0658 11.7328V12.5328ZM16.1441 13.4719C16.1441 12.9451 16.5585 12.5328 17.0658 12.5328V11.7328C16.1069 11.7328 15.3441 12.5131 15.3441 13.4719H16.1441Z",
    fill: "url(#paint3_linear_816_2285)",
    mask: "url(#path-5-inside-1_816_2285)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_816_2285",
    x: -3.86407,
    y: -4.60963,
    width: 44.4524,
    height: 44.5896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_816_2285"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_816_2285",
    x: -23,
    y: -22,
    width: 70.6519,
    height: 70.8917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_816_2285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_816_2285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_816_2285",
    x: -8.77661,
    y: -2.86732,
    width: 42.1642,
    height: 32.6785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_816_2285"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_816_2285",
    result: "effect2_dropShadow_816_2285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_816_2285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_2285",
    x1: 18.4372,
    y1: 9.40503,
    x2: 18.4372,
    y2: 25.7773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F66FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_816_2285",
    x1: 5.28745,
    y1: 5.43391,
    x2: 18.6457,
    y2: 21.7886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_816_2285",
    x1: 17.5251,
    y1: 12.6163,
    x2: 4.25205,
    y2: 14.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_816_2285",
    x1: 8.15973,
    y1: 12.4447,
    x2: 8.76209,
    y2: 15.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_816_2285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNew);
export default __webpack_public_path__ + "static/media/Chat-New.2d8693b4924a2452bf1c837d283bd808.svg";
export { ForwardRef as ReactComponent };